import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import TemplateService from './template.service';
import { enqueueSnackbar } from 'notistack';

type ActionType = 'downloadOrPrintTemplate';

interface MutationAction {
  actionType: ActionType;
  [key: string]: any;
}

const useTicketPrint = (): {
  downloadOrPrintTemplate: UseMutationResult<any, unknown, MutationAction, unknown>['mutate'];
  isDownloadingOrPrintingTicketTemplate: Record<string, boolean>;
  setIsDownloadingOrPrintingTicketTemplate: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
} => {
  const [isDownloadingOrPrintingTicketTemplate, setIsDownloadingOrPrintingTicketTemplate] = useState<Record<string, boolean>>({});
  const queryClient = useQueryClient();
  const executeMutation = async ({ actionType, ...payload }: MutationAction) => {
    const templateService = TemplateService();
    const action: { [key in ActionType]?: Function } = {
      downloadOrPrintTemplate: templateService.postPopulatedTemplate,
      // deleteTicket: ticketService.deleteTicket
    };

    const serviceMethod = action[actionType];
    if (!serviceMethod) {
      throw new Error(`Unknown action type: ${actionType}`);
    }
    return serviceMethod(payload);
  };

  const { mutateAsync: downloadOrPrintTemplate } = useMutation<any, unknown, MutationAction>({
    mutationFn: executeMutation,
    onMutate: ({ actionType }) => {
      setIsDownloadingOrPrintingTicketTemplate({ ...isDownloadingOrPrintingTicketTemplate, [actionType]: true });
    },
    onSuccess: (data: any, variables: any) => {
      console.log('ticket print/download onSuccess:', data, variables);
      // console.log('Mutation successful');
      // console.log('Base Field variables.data:', variables.data);
      // queryClient.invalidateQueries({ queryKey: ['all-tickets'] });
      // if (Object.keys(variables.data).length > 2 && variables.actionType === 'updateTicketPrint') {
      //   console.log('successful update');
      //   enqueueSnackbar('Base Fields saved successfully', { variant: 'success' });
      // } else if (variables.data.TId && variables.actionType === 'updateTicketPrint') {
      //   // console.log('successful update');
      //   enqueueSnackbar('Base Field saved successfully', { variant: 'success' });
      // }
      // if (variables.actionType === 'deleteTicket' && data.ticketId) {
      //     queryClient.removeQueries({ queryKey: ['ticket', data.ticketId] })
      //     enqueueSnackbar(`Ticket #${data.ticketId} deleted successfully`, { variant: 'success' })
      //     queryClient.invalidateQueries({ queryKey: ['archived-tickets'], exact: true });
      // }
    },
    onError: (error: any, variables: any) => {
      console.error('Error during mutation:', error);
      // console.warn('ERROR', variables);
      // if (Object.keys(variables.data).length > 2 && variables.actionType === 'updateTicketPrint') {
      //   enqueueSnackbar('Base Field updates failed', { variant: 'error' });
      // } else if (variables.data.TId && variables.actionType === 'updateTicketPrint') {
      //   enqueueSnackbar('Base Field update failed', { variant: 'error' });
      // }

      if (variables.actionType === 'deleteTicket' && variables.data.TId) {
        enqueueSnackbar(`Ticket #${variables.data[0].TicketID} delete failed`, {
          variant: 'error',
        });
      }
    },
    // onSettled: ({ actionType }) => {
    //   setIsDownloadingOrPrinting({ ...TemplatenloadingOrPrinting, [actTemplatepe]: false });
    // },
    onSettled: () => {
      // queryClient.invalidateQueries();
    },
  });

  return { downloadOrPrintTemplate, isDownloadingOrPrintingTicketTemplate, setIsDownloadingOrPrintingTicketTemplate };
};

export default useTicketPrint;
